export function totalModelTokens(inputTokens, outputTokens) {
  return (inputTokens || 0) + (outputTokens || 0);
}
